import { __decorate } from "tslib";
import { Component, Mixins } from 'vue-property-decorator';
import { Mutation } from 'vuex-class';
// import { mixins } from 'vue-class-component';
import SegmentAnalyticsMixin from '@/helpers/vue_mixins/v2/SegmentAnalyticsMixin';
import PageSettingMixin from '@/helpers/vue_mixins/v2/PageSettingMixin';
import BaseOverlayLoader from '@/components/v2/BaseOverlayLoader';
import OperatingLeadTimeMixin from '@/helpers/vue_mixins/v2/OperatingLeadTimeMixin';
import PageSettingsForm from '@/components/v2/PageSettingsForm.vue';
import AlertMixin from '@/helpers/vue_mixins/AlertMixin';
import CleverTapEventsMixin from '@/helpers/vue_mixins/v3/CleverTapEventsMixin';
import { Bundle } from '@/helpers/entities/enums/v2/Bundle';
let PageSettings = class PageSettings extends Mixins(AlertMixin, PageSettingMixin, SegmentAnalyticsMixin, CleverTapEventsMixin, OperatingLeadTimeMixin) {
    constructor() {
        super(...arguments);
        this.onSubmitLoading = false;
    }
    get queryOnFlight() {
        if (this.onSubmitLoading && !this.diy) {
            return false;
        }
        return this.$apollo.loading;
    }
    async skipNotifUpdateOnDiy(form) {
        if (!this.diy) {
            this.updateMiniAppNotifs(form);
        }
    }
    async saveStoreTitle(form) {
        if (!this.diy && this.isMallStoresManagement) {
            this.updateStoreTitle(form);
        }
    }
    async saveOperatingLeadTime(form) {
        if (this.$route.params.key === Bundle.Shopify) {
            const operatingLeadTimeForm = {
                appUuid: form.appUuid,
                enableLeadTime: form.enableLeadTime,
                enableOperatingHours: form.enableOperatingHours,
                leadTimeValue: form.enableLeadTime && form.leadTimeValue ? form.leadTimeValue.toString() : null,
                openingHour: form.openingHour,
                closingHour: form.closingHour,
                allowClosingHoursOrder: form.allowClosingHoursOrder,
            };
            this.updateOperatingAndLeadTime(operatingLeadTimeForm);
        }
    }
    async onSubmit(form) {
        this.onSubmitLoading = true;
        try {
            this.requestOnFlight();
            await Promise.all([
                this.updateApp(form),
                this.updateGreeting(form),
                this.updateWelcomeMessage(form),
                this.updateWelcomeImage(form),
                this.updatePersistentMenu(form),
                this.skipNotifUpdateOnDiy(form),
                this.saveStoreTitle(form),
            ]);
            this.requestDone();
            await this.$apollo.queries.app?.refetch();
            await this.$apollo.queries.greeting?.refetch();
            await this.$apollo.queries.storeTitle?.refetch();
            await this.$apollo.queries.welcomeMessage?.refetch();
            this.onSubmitLoading = false;
            if (this.diy) {
                this.segmentTrack('DIY Step 3 - Customize App Settings', form);
                this.onNext();
                this.onDIYSubmitAppSettings(!!form.appName, !!form.greeting, !!form.welcomeMessageContent, !!form.welcomeButtonTitle, !!form.referralCode, !!form.emailNotifRecipients.length, !!form.supportEmailList.length, !!form.supportContactNumber);
            }
            else {
                this.successNotification('Successfully Updated');
            }
            this.clearPersistentErrorNotification();
        }
        catch (e) {
            this.requestDone();
            this.errorNotification(e.message);
            this.onSubmitLoading = false;
        }
    }
};
__decorate([
    Mutation('requestOnFlight')
], PageSettings.prototype, "requestOnFlight", void 0);
__decorate([
    Mutation('requestDone')
], PageSettings.prototype, "requestDone", void 0);
PageSettings = __decorate([
    Component({
        components: {
            BaseOverlayLoader,
            PageSettingsForm,
        },
    })
], PageSettings);
export default PageSettings;
